import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ cost, nextCost }) =>
    present(
      repository
        .updateCost(cost, nextCost)
        .then(() => ({ cost, nextCost }))
        .catch(() => Promise.reject({ cost, nextCost })),
    );
}

export type { Interactor };

export { createInteractor };
